import React, { Component } from "react";
import ScreenView from "./ScreenView";
import "./stylesNew.css";

class AppView extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.setState({ expanded: !this.state.expanded });
  }

  componentDidMount() {
    console.log("TREE: " + this.props.app.get("name"));
  }

  componentDidCatch(error, info) {
    console.log("ERROR " + error);
  }

  render() {
    /*const Screens = ({ screens }) => {
      return !screens
        ? ""
        : screens.map(screen => {
            console.log("screen: " + JSON.stringify(screen));
            return <ScreenView screen={screen} />;
          });
    };
    var screens = "";
    if (this.props.app.get("screens"))
      screens = this.props.app.get("screens").map(screen => {
        console.log("screen: " + JSON.stringify(screen));
        return <ScreenView screen={screen} />;
      });
    var singletons = "";
    if (this.props.app.get("singletons"))
      singletons = this.props.app
        .get("singletons")
        .map(singleton => (
          <span className="Singleton">{singleton.get("name")}</span>
        ));*/
    return (
      <div
        className="App"
        style={{ width: "fit-content" }}
        onClick={e => {
          e.stopPropagation();
          this.handleClick(e);
        }}
      >
        <div className="AppTitle">{this.props.app.get("name")}</div>
        <br />
        {this.props.children}
      </div>
    );
  }
}

export default AppView;



// WEBPACK FOOTER //
// ./src/components/AppView.js